import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { badge } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function MyOrders() {
  const { go, set, L } = useApp();
  const tStatus = (s: string) => L(s, ({ 'Active': 'ใช้งานอยู่', 'Pending Approval': 'รออนุมัติ' } as Record<string, string>)[s] ?? s);
  const myOrdKpis = [
    { label: L('Total POs', 'ใบสั่งซื้อทั้งหมด'), value: '3' },
    { label: L('Active', 'ใช้งานอยู่'), value: '2' },
    { label: L('Awaiting Invoice', 'รอใบแจ้งหนี้'), value: '1' },
    { label: L('Total Value', 'มูลค่ารวม'), value: '$10.02M' },
  ];
  const myOrders = [
    { id: 'PO-2026-0041', desc: 'Fleet Vehicle Insurance — Class 1', value: '$4,620,000', issued: '2026-06-22', due: '2026-07-01', status: 'Active', inv: 'INV-2026-0063' },
    { id: 'PO-2026-0047', desc: 'Property All-Risk Insurance', value: '$5,400,000', issued: '2026-06-21', due: '2026-07-05', status: 'Pending Approval', inv: 'Not Submitted' },
  ].map((p) => {
    const b = badge(p.status);
    return { ...p, stBg: b.bg, stFg: b.fg, invWarn: p.inv === 'Not Submitted' };
  });

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {myOrdKpis.map((k) => (
          <div key={k.label} style={cardPad('16px 18px')}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 6 }}>{k.label}</div>
            <div style={{ fontSize: 22, fontWeight: 700, fontFamily: 'var(--font-mono)' }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={cardPad(0, 'auto')}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 820 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('PO Number', 'เลขที่ใบสั่งซื้อ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Description', 'รายละเอียด')}</th>
              <th style={{ textAlign: 'right', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Value', 'มูลค่า')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Issued', 'ออกเมื่อ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Delivery Due', 'กำหนดส่งมอบ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Status', 'สถานะ')}</th>
              <th style={{ textAlign: 'left', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Invoices', 'ใบแจ้งหนี้')}</th>
              <th style={{ textAlign: 'right', padding: '11px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Actions', 'การดำเนินการ')}</th>
            </tr>
          </thead>
          <tbody>
            {myOrders.map((p) => (
              <tr key={p.id} style={{ borderBottom: '1px solid var(--color-border)' }}>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{p.id}</td>
                <td style={{ padding: '12px 16px' }}>{p.desc}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{p.value}</td>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{p.issued}</td>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{p.due}</td>
                <td style={{ padding: '12px 16px' }}><span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: p.stBg, color: p.stFg }}>{tStatus(p.status)}</span></td>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--color-fg-2)' }}>{p.inv === 'Not Submitted' ? L('Not Submitted', 'ยังไม่ได้ส่ง') : p.inv}</td>
                <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                  <button onClick={() => { set({ openedPo: { id: p.id, desc: p.desc, sup: 'Apex Insurance Co.', value: p.value, doa: '', pending: false, status: p.status, invoiced: !p.invWarn } }); go('supplierpodetail'); }} className="hv-blue" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 'var(--radius-sm)', background: 'var(--color-blue)', color: '#fff' }}><Icon name="arrow-right" />{L('Open', 'เปิด')}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
